export const EN_LANGUAGE = {
    "ui.vr.start": "Start VR",
    "ui.vr.end": "Exit VR",
    "ui.vr.tooltip.waiting": "Waiting for HMD initialization...",
    "ui.xr.notSupported": "WebVR not supported.",
    "ui.xr.requiresHttps": "WebXR requires a secure connection.",
    "ui.xr.noImmersiveSession": "immersive-vr session is not supported.",
    "ui.mic.muted": "You're muted",
    "ui.mic.unmuted": "Your mute is cancelled",
    "ui.mic.tooltip.mute": "Mute microphone",
    "ui.mic.tooltip.unmute": "Unmute microphone",
    "ui.mic.tooltip.remoteMute": "Mute members",
    "ui.mic.tooltip.remoteUnmute": "Unmute members",
    "ui.editAccount": "Edit account",
    "ui.logout": "Logout",
    "ui.shareSession": "Share session",
    "ui.shareSession.deactivated": "Sharing session not allowed",
    "ui.input.positive": "Positive",
    "ui.input.negative": "Negative",
    "ui.exitRoom": "Exit room",
    "ui.user.profile": "User profile",
    // UI
    "roomEnter": "Enter room",
    "roomLoad": "Load room",
    "openMenu": "Open menu",
    "openContextMenu": "Open object contextmenu",
    "gestureMove": "Move",
    // Interactions
    "interaction.transformModel": "Move/Scale object",
    "interaction.transformHandle.rotate": "Rotate object",
    "interaction.transformHandle.scale": "Scale object",
    "interaction.transformHandle.translate": "Move object",
    "interaction.flyToHitpoint": "Fly to hitpoint",
    "interaction.grabbable": "Move object",
    "interaction.room.awaitLoading": "Room hasn't finished loading",
    "room.change.rejected.busy": "Can't change room,\nbecause this client is geneating a Layout",
    // Colors
    "black": "black",
    "grey": "grey",
    "white": "white",
    "orange": "orange",
    "yellow": "yellow",
    "green": "green",
    "turquoise": "turquoise",
    "blue": "blue",
    "magenta": "magenta",
    "red": "red",
    "brown": "brown",
    // Shapes
    "box": "box",
    "sphere": "sphere",
    "cylinder": "cylinder",
    "cone": "cone",
    "pyramid": "pyramid",
    "prism": "prism",
    // Layouts
    "menger.layoutName": "Menger Sponge",
    "random.layoutName": "Random",
    "sysmon.layoutName": "System Monitor",
    "database.layoutName": "Database",
    "projectTree.layoutName": "Controlling",
    "projectTree.geolocation.layoutName": "Controlling\n(GeoLocations)",
    "projectTree.interaction.projectView.reset": "hide project details",
    "projectTree.interaction.projectView.workPerMonth": "show more details",
    "projectTree.interaction.projectView.workPerPerson": "show even more details",
    "sandbox.layoutName": "Sandbox",
    "sandbox.ui.room.button.modelCreation": "object\ncreation\noptions",
    "sandbox.ui.room.button.modelTrasform": "object\ntransformation\noptions",
    "sandbox.ui.room.button.record.start": "start recording",
    "sandbox.ui.room.button.record.stop": "stop recording",
    "sandbox.ui.room.button.replay": "play recording",
    "sandbox.ui.editModel.title": "edit object",
    "sandbox.ui.editModel.button.label": "label",
    "sandbox.ui.editModel.button.shape": "change shape",
    "sandbox.ui.editModel.button.color": "change color",
    "sandbox.ui.editModel.button.gravity": "gryvity",
    "sandbox.ui.editModel.button.transform": "transform handles",
    "sandbox.ui.editModel.button.connection": "connection",
    "sandbox.ui.editModel.button.delete": "delete",
    "sandbox.ui.connection.title": "connection color",
    "sandbox.ui.color.title": "change shape",
    "sandbox.ui.shape.title": "change shape",
    "sandbox.ui.modelCreation.title": "object creation options",
    "sandbox.ui.modelCreation.button.shape": "change default shape",
    "sandbox.ui.modelCreation.button.color": "change default color",
    "sandbox.ui.modelCreation.button.connection": "change default connection color",
    "sandbox.ui.modelCreation.button.room": "new objecte are rooms",
    "sandbox.ui.modelTrasform.title": "object transformation options",
    "sandbox.ui.modelTrasform.button.enableGrid": "align to grid",
    "sandbox.ui.modelTrasform.button.gridSize": "grid size",
    "sandbox.ui.modelTrasform.button.snapAngle": "snape angle",
    "sandbox.ui.modelTrasform.button.scaleStepSize": "scaling step size",
    "sandbox.ui.gridSize.title": "grid size",
    "sandbox.ui.snapAngle.title": "snap angle",
    "sandbox.ui.scaleStepSize.title": "skaling stel size",
    "sandbox.interaction.createModel": "create object",
    "hm.button.start": "Start",
    "hm.button.selectProject": "Select project",
    "hm.button.releaseSelection": "Release selection",
    "hm.button.showBackground": "Show background",
    "hm.button.exit": "Exit",
    "YearMonth1": "{year}\nJan.",
    "YearMonth2": "{year}\nFeb.",
    "YearMonth3": "{year}\nMar.",
    "YearMonth4": "{year}\nApr.",
    "YearMonth5": "{year}\nMay",
    "YearMonth6": "{year}\nJun.",
    "YearMonth7": "{year}\nJul.",
    "YearMonth8": "{year}\nAug.",
    "YearMonth9": "{year}\nSep.",
    "YearMonth10": "{year}\nOct.",
    "YearMonth11": "{year}\nNov.",
    "YearMonth12": "{year}\nDec.",
    "avatar.clothing": "Clothing",
    "avatar.headgear": "Headgear",
    "avatar.preset": "Preset",
    "avatar.basecolor": "Base color",
    "avatar.name.description": "Display name:",
    "avatar.setup": "  Avatar setup",
    "default.button.back": "Back",
    "default.button.continue": "Continue",
    "default.error.message": "An error occurred!",
    "mic": "Microphone:",
    "mic.access.request.message": "microphone access will be requested.",
    "mic.access.required.message": "If you want to talk you need to grant access to your microphone.",
    "mic.activated": "Microphone activated",
    "mic.deactivated": "Microphone deactivated",
    "mic.setup": "Microphone setup",
    "speakers": "Speakers:",
    "speakers.activated": "Speakers activated",
    "speakers.deactivated": "Speakers deactivated",
    "audio.warning": "To hear other participants please click into the browser window",
    "camera.access.required.message": "To use you camera you need to grant access to it.",
    "camera.activated": "camera activated",
    "camera.deactivated": "camera deactivated",
    "camera.setup": "Camera setup",
    "camera.preview": "Preview",
    "api.error.session.name.duplicated": "The chosen name is already used. Please keep in mind that the comparison doesn't take into account the difference between capital and lower case letters."
};
